__turbopack_context__.v({
  "container": "styles-module__lSpbrW__container",
});
